module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// LazyLoad Widget

(function (fox, $) {
	
	fox.registerWidget('LazyLoad', {

		configure: function () {
			this.registerOptions('', {
				checkScrollingStatusTime: 500,
				handleWom: {
					scrollStop: {
						event: 'scrollStop',
						widget: '@this',
						callback: 'scrollStopHandler'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._window = window;
			this._currentWindowPosition = this._window.scrollY;
			this._dinamycValues = [];
			this._scrollStatus = false;

			this.addDomHandler({
				event: 'scroll',
				target: document,
				callback: 'scrollingHandler'
			}, 'scrolling')
		
			this.callParent('init', arguments);
		},

		scrollingHandler: function (el, alias, performer, event) {;

			if (!this._dinamycValues.length) {

			}

			this._dinamycValues.push(this._window.scrollY);
		},

		scrollStopHandler: function () {
			
			this._clearDinamyc();
		},

		_clearDinamyc: function () {
			this._dinamycValues = [];
		},


	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/lazyload.js
// module id = 859
// module chunks = 4